import { createContext, useState, SetStateAction, Dispatch, PropsWithChildren } from 'react';

const noop = () => {};

const tooltipContext = {
   openDataPointId: null as string | null,
   setOpenDataPointId: noop as Dispatch<SetStateAction<string | null>>,
};

const TooltipContext = createContext(tooltipContext);

function OpenTooltipProvider({
   initialOpenDataPointId,
   children,
}: PropsWithChildren<{ initialOpenDataPointId?: string }>) {
   const [openDataPointId, setOpenDataPointId] = useState(initialOpenDataPointId || null);

   const tooltipContext = {
      openDataPointId,
      setOpenDataPointId,
   };

   return <TooltipContext.Provider value={tooltipContext}>{children}</TooltipContext.Provider>;
}

export { OpenTooltipProvider, TooltipContext };
